import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "../ui/card";

const SummaryCard = ({ title, icon, value, subtitle, progress }) => (
  <Card className="bg-gradient-to-br from-white to-indigo-50 border border-indigo-100 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden">
    <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
      <CardTitle className="text-sm font-medium text-indigo-700">{title}</CardTitle>
      <div className="bg-indigo-100 p-2 rounded-lg">
        {React.cloneElement(icon, { className: "h-4 w-4 text-indigo-700" })}
      </div>
    </CardHeader>
    <CardContent>
      <div className="text-2xl font-bold text-gray-800">{value}</div>
      {progress !== undefined && <progress value={progress} max={100} className="w-full mt-2" />}
      {subtitle && <p className="text-xs text-indigo-500 mt-2">{subtitle}</p>}
    </CardContent>
  </Card>
);

export default SummaryCard;